import { Injectable } from '@angular/core';
// import { BrandConfig } from '@models/BrandConfig';
import { IPartnerData } from '@models/WhitelabelConfig';

import { BrandConfigStore } from './brand.store';

@Injectable({ providedIn: 'root' })
export class BrandConfigService {
	constructor(private readonly brandConfigStore: BrandConfigStore) { }

	public update(config: IPartnerData): void {
		this.brandConfigStore.update(state => (config));
	}
}
